<div class="madar--v2">
  <button mat-icon-button>
    <app-icon name="menu-vert"  class="cursor-pointer text-700"></app-icon>
  </button>
</div>
